// User roles, shared by server and client (client import: `api/core/roles`). Pure functions only.
// admin (profile.admin) is the existing admin role; it verifies owners and reviews communities.
// superadmin (profile.superadmin) is a separate role, NOT an admin: for now it only opens the
// maintenance dashboard. Both flags live in profile for now; clients can't write it (core/server/users.js deny,
// admin dropped at sign-up in owners/rules.js). Moving them out of profile is GitHub issue #11.
var profileOf = function profileOf(user) {
  return user && user.profile || {};
};

export var isAdmin = function isAdmin(user) {
  return profileOf(user).admin === true;
}; // the admin's screens in the browser: an admin, or the test server's demo admin (#472; profile.demoAdmin, set by the
// server only). For what is shown only: the server keeps the demo admin to demo data itself (demo/server/access.js)

export var seesAdminScreens = function seesAdminScreens(user) {
  return isAdmin(user) || profileOf(user).demoAdmin === true;
};
export var isSuperadmin = function isSuperadmin(user) {
  return profileOf(user).superadmin === true;
}; // a fan: not an owner, not admin, not superadmin (the fans counts on /admin/fans and /admin/communities)

export var isFan = function isFan(user) {
  return !!user && profileOf(user).owner !== true && !seesAdminScreens(user) && !isSuperadmin(user);
}; // an account that is only superadmin (not admin, not owner) sees nothing but the maintenance screen

export var isSuperadminOnly = function isSuperadminOnly(user) {
  return isSuperadmin(user) && !isAdmin(user) && profileOf(user).owner !== true;
};